<hlm-toaster position="top-right" />
<app-loader [isLoading]="isLoading()" />
<router-outlet />
